import React, { useState } from "react";
import "./FAQ.css";

const leftColumn = [
  {
    question: "What is the Glamur Paint Visualiser?",
    answer:
      "It’s a super handy tool that lets you see how different colors will look on your walls before you even open a paint can. Try, mix, and match shades in real time!",
  },
  {
    question: "How do I use the Paint Visualiser?",
    answer:
      "Just choose one from our sample gallery, then pick your favorite Glamur shades. The tool will instantly show you how they look on your walls.",
  },
];

const rightColumn = [
  {
    question: "Do I need to download anything?",
    answer:
      "Nope! The Visualiser works right on our website — no app, no download, just instant color magic.",
  },
  {
    question: "Can I save or share my designs?",
    answer:
      "Yes! You can save your favorite color combinations or share them with family, friends, or your interior designer to help you decide faster.",
  },
  {
    question: "Are the colors in the Visualiser 100% accurate?",
    answer:
      "They’re super close, but keep in mind that screen brightness and lighting can slightly affect how colors appear. For perfect accuracy, check a sample swatch before painting.",
  },
];

const FAQvis = () => {
  // ✅ Default active question — first item of left column
  const [activeIndex, setActiveIndex] = useState("L0");

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const renderFAQItem = (item, index, columnPrefix) => (
    <div
      key={columnPrefix + index}
      className={`faq-item ${
        activeIndex === columnPrefix + index ? "active" : ""
      }`}
      onClick={() => toggleFAQ(columnPrefix + index)}
    >
      <div className="faq-question">
        <span className="faq-icon">
          {activeIndex === columnPrefix + index ? "–" : "+"}
        </span>
        <h3>{item.question}</h3>
      </div>
      {activeIndex === columnPrefix + index && item.answer && (
        <p className="faq-answer">{item.answer}</p>
      )}
    </div>
  );

  return (
    <section className="faq-section">
      <h2 className="faq-title">Paint Visualiser – Frequently Asked Questions</h2>
      <div className="faq-columns">
        <div className="faq-column">
          {leftColumn.map((item, i) => renderFAQItem(item, i, "L"))}
        </div>
        <div className="faq-column">
          {rightColumn.map((item, i) => renderFAQItem(item, i, "R"))}
        </div>
      </div>
    </section>
  );
};

export default FAQvis;
